import { Languages } from '../../enums/Languages';


export class PhoneLanguageDto {
  public phone: string;
  public language: Languages;

  constructor() {
    this.empty();
  }

  public static build(p: string, l: Languages): PhoneLanguageDto {
    let result = new PhoneLanguageDto();
    result.phone = p;
    result.language = l;
    return result;
  }

  public static buildByDto(dto: PhoneLanguageDto): PhoneLanguageDto {
    let result = new PhoneLanguageDto();
    result.copyFrom(dto);
    return result;
  }

  public empty(): PhoneLanguageDto {
    this.phone = "";
    this.language = Languages.es;
    return this;
  }

  public copyFrom(dto: PhoneLanguageDto) {
    this.phone = dto.phone;
    this.language = dto.language;
  }
}
